import { BookDto } from './book.model';
import { Book } from '@lyceo/lyceo-pupil-app/practise/util-models';
import { ChapterDto } from '../chapter/chapter.model';

export function mapBook(bookDto: BookDto): Book {
  return {
    id: bookDto.id,
    name: bookDto.name,
    methodId: bookDto.method.id,
    subjectName: bookDto.subject.name,
    finalExam: bookDto.finalExam,
    lastParagraphId: getLastParagraphId(bookDto),
  };
}

export function getLastParagraphId(bookDto: BookDto): string | undefined {
  if (bookDto.chapters.length) {
    const lastChapter: ChapterDto =
      bookDto.chapters[bookDto.chapters.length - 1];
    if (lastChapter.paragraphs.length) {
      return lastChapter.paragraphs[lastChapter.paragraphs.length - 1].id;
    }
  }
  return undefined;
}
